<template>
    <div class="bg-white rounded px-7 pt-7 pb-4 w-full shadow-card">
        <h4 class="font-medium mb-2">Resumo</h4>
        <div>
            <span class="text-xs text-gray-500 opacity-90 mb-1">Favorecido</span>
            <favored class="py-0 pl-0 pointer-events-none border-none" :favored="favored"/>
        </div>
        <div class="mt-5">
            <span class="block text-xs text-gray-500 opacity-90">Banco destinado</span>
            <div class="text-xs mt-1">
                {{ `${favored.bank.number ? `${favored.bank.number} - ` : ''}` }}{{ favored.bank.description }}
            </div>
            <div class="flex mt-1">
                <div class="mr-5">
                    <small class="block text-gray-500 opacity-80">Agência</small>
                    <span class="block text-xs">{{ favored.account.agency }}</span>
                </div>
                <div>
                    <small class="block text-gray-500 opacity-80">Conta</small>
                    <span class="block text-xs">{{ favored.account.account }}</span>
                </div>
            </div>
        </div>
        <div class="flex justify-between items-end flex-wrap lg:flex-nowrap">
            <div class="xl:mr-7 lg:mr-3">
                <div class="mt-5 w-52">
                    <span class="block text-xs text-gray-500 opacity-90">Identificador de cobrança</span>
                    <div class="text-xs mt-1">{{ form.receiver_code || '--' }}</div>
                </div>
                <div class="mt-5 w-52">
                    <span class="block text-xs text-gray-500 opacity-90">Descrição</span>
                    <p class="text-xs mt-1 h-12 overflow-y-auto">
                        {{ form.description || '--' }}
                    </p>
                </div>
                <div class="mt-5">
                    <span class="block text-xs text-gray-500 opacity-90">Valor</span>
                    <div class="flex font-bold items-end mt-1">
                        <span class="text-xs mr-1">R$</span>
                        <h3 class="text-xl leading-none">{{ form.amount || '0,00' }}</h3>
                    </div>
                </div>
            </div>
            <form class="relative w-full lg:w-auto" @submit.prevent="$emit('submit')">
                <div class="xl:w-52 lg:w-44 md:w-full">
                    <div v-if="false" class="relative">
                        <div class="text-xs text-center">Agendar pagamento para</div>
                        <jet-date-picker
                            :is-clear-button="false"
                            :is-calendar-button="true"
                            :calendar-button-icon="'fa fa-calendar'"
                            :value="''"
                            :format="formatDate"
                        />

                    </div>
                    <div class="mt-4">
                        <div class="text-xs text-center">Código de autorização</div>
                        <jet-input
                            id="google_code"
                            type="text"
                            class="mt-1 block w-full text-md"
                            @input="$emit('input', { type: 'google_code', value: $event })"
                        />
                        <jet-input-error :message="form.error('google_code')" class="mt-1" />
                    </div>
                    <button
                        class=" text-white leading-none py-3 rounded w-full mt-3 text-xs"
                        type="submit"
                        :class="form.processing ? 'cursor-not-allowed bg-gray-300': 'bg-green-500 hover:bg-green-600'"
                        :disabled="form.processing"
                    >
                        <i v-show="form.processing" class="fas fa-spinner animate-spin mr-1"></i>
                        Concluir transferência
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import JetDatePicker from "../../../Jetstream/DatePicker.vue";
import JetInput from "../../../Jetstream/Input.vue";
import JetInputError from "../../../Jetstream/InputError.vue";
import Favored from './Favored.vue';

export default {
    name: 'FormSummary',
    props: {
        form: { type: Object, default: () => ({}) },
        favored: { type: Object, required: true  }
    },
    computed: {
        formatDate(){
            const formatDatePicker = 'dd/MM/yyyy'
            const format = 'DD/MM/YYYY'
            return moment(this.datePix).format(format) === moment().format(format)
                ? formatDatePicker + " \(Hoje\)"
                : formatDatePicker
        },
    },
    components: {
        JetDatePicker,
        JetInput,
        JetInputError,
        Favored
    }
}
</script>
